// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__582bw","container":"App_container__1nYjx"};